// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"4d7f2658","182":"ba5fb5b9","434":"d8d01198","448":"5416ce00","497":"8113ce72","743":"f4b5de04","768":"d00a4e08","873":"2b659a79"}[chunkId] + ".chunk.js";
};